"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserOnboarded = isUserOnboarded;
exports.isEmployerAndTeamMember = isEmployerAndTeamMember;
exports.isCompanyVerified = isCompanyVerified;
exports.getUserRole = getUserRole;
exports.isEmployee = isEmployee;
exports.isServiceProvider = isServiceProvider;
exports.isEmployer = isEmployer;
exports.userCan = userCan;
exports.formatRole = formatRole;
exports.getUserCountry = getUserCountry;

var _roleAuthorization = _interopRequireDefault(require("../../../../config/roleAuthorization"));

var _constants = require("../../../companies/constants");

var _constants2 = require("../../../employment/constants");

var _constants3 = require("../constants");

var _general = require("../../../../helpers/general");

/**
 * Helper function to verify if the user already completed the onboarding.
 * @param {Object} user
 */
function isUserOnboarded(user) {
  var status = user.status;
  return !['initiated', 'created'].includes(status);
}
/**
 * Employer that is not the 'owner' of the company account (viewer or admin)
 * @param {Object} user
 */


function isEmployerAndTeamMember(user) {
  var role = user.role,
      teamMember = user.teamMember;
  return role === _constants3.userRole.EMPLOYER && [_constants3.teamMemberValues.ADMIN, _constants3.teamMemberValues.VIEWER].includes(teamMember === null || teamMember === void 0 ? void 0 : teamMember.role);
}
/**
 * Helper function to verify if the user user's company has been verified.
 * @param {Object} user
 */


function isCompanyVerified(user) {
  return (user === null || user === void 0 ? void 0 : user.companyStatus) === _constants.companyStatus.ACTIVE;
}
/**
 * Get user role
 *
 * @param {Object} user The user object
 */


function getUserRole(_ref) {
  var role = _ref.role,
      activeEmployment = _ref.activeEmployment,
      teamMember = _ref.teamMember;
  var user = {
    role: role,
    teamMember: teamMember
  };

  if (isEmployerAndTeamMember(user) && role === _constants3.userRole.EMPLOYEE) {
    user.role = _constants3.userRole.EMPLOYEE;
  } else {
    switch (true) {
      case role === _constants3.userRole.EMPLOYEE && (activeEmployment === null || activeEmployment === void 0 ? void 0 : activeEmployment.type) === _constants2.employmentType.FULL_TIME:
        user.role = _constants3.userRole.EMPLOYEE;
        break;

      case role === _constants3.userRole.EMPLOYEE:
        // a contractor has the employee role
        // with employement type 'contractor';
        user.role = _constants2.employmentType.CONTRACTOR;
        break;
    }
  }

  return user;
}

function isEmployee() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _getUserRole = getUserRole(user),
      role = _getUserRole.role;

  return role === _constants3.userRole.EMPLOYEE;
}

function isServiceProvider(user) {
  return user.role === _constants3.userRole.SERVICE_PROVIDER;
}

function isEmployer(user) {
  return (user === null || user === void 0 ? void 0 : user.role) === _constants3.userRole.EMPLOYER;
}
/**
 * Check if user can preform operation on feature
 *
 * @param {String} operation The kind of operation allowed. create, read, update, delete
 * @param {String} feature The feature if. E.g. personal_details
 * @param {Object} user The user object
 * @param {String} user.role The user role
 * @param {Object} featuresMap Fallback features map `{ role: feature_id: [ operation, ] }`
 */


function userCan(operation, feature) {
  var user = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var featuresMap = arguments.length > 3 ? arguments[3] : undefined;

  var _getUserRole2 = getUserRole(user),
      role = _getUserRole2.role,
      teamMember = _getUserRole2.teamMember;

  if (!role) {
    return false;
  }

  var allowedFeatures = null;
  var features = featuresMap || _roleAuthorization["default"];

  if (teamMember !== null && teamMember !== void 0 && teamMember.role && role === _constants3.userRole.EMPLOYER) {
    allowedFeatures = features.teamMember[teamMember.role] || {};
  } else {
    allowedFeatures = features[role] || {};
  }

  var hasFeature = typeof allowedFeatures[feature] !== 'undefined';
  return hasFeature && allowedFeatures[feature].includes(operation);
}
/**
 * Format user role
 *
 * Transforms service_provider into Service provider
 * @param {String} role The user role
 */


function formatRole() {
  var role = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (0, _general.friendlyKeyToLabel)(role);
}
/**
 * Get user country label
 *
 * @param {Object} user The user object
 * @param {Object} user.contract The user contract
 * @param {Object} user.contract.country The contract country object
 * @param {String} user.contract.country.name The country name
 */


function getUserCountry(user) {
  var country = user.contract && user.contract.country || {};
  return country.name ? country : null;
}